import * as types from "../../actionTypes";

const initialState = {
  data: {},
  isLoading: false,
  message: "",
  status: "",
};

const socialMediaReducer = (state = initialState, action) => {
  console.log("prd", action);
  switch (action.type) {
    case types.ADD_SOCIAL_MEDIA_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case types.ADD_SOCIAL_MEDIA_SUCCESS:
      return {
        ...state,
        isLoading: false,
        status: action.payload.status,
        message: action.payload.message,
      };
    case types.ADD_SOCIAL_MEDIA_FAILURE:
      console.log(action.payload);
      return {
        ...state,
        isLoading: false,
        data: {},
        status: action.payload.status,
        message: action.payload.message,
      };
    case types.DELETE_SOCIAL_MEDIA_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case types.DELETE_SOCIAL_MEDIA_SUCCESS:
      return {
        ...state,
        isLoading: false,
        status: action.payload.status,
        message: action.payload.message,
      };
    case types.DELETE_SOCIAL_MEDIA_FAILURE:
      return {
        ...state,
        isLoading: false,
        status: action.payload.status,
        message: action.payload.message,
      };
    case types.RESET_DATA:
      return {
        ...state,
        isLoading: false,
        data: {},
        status: false,
        message: "",
      };

    default:
      return state;
  }
};

export default socialMediaReducer;
